import React,{useState,useEffect,useContext} from 'react';
import PropTypes from 'prop-types';
import NumberFormatCustom  from './NumberFormatCustom';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import moment from "moment";
import numeral from "numeral";
import * as utils  from "../utils";
import AuthContext from "./auth/Context";

import FormControl from '@mui/material/FormControl';


function NumberField(props) {
    let { row,field,onChange,value,readOnly,format,helperText,InputProps,inputProps,InputLabelProps,fullWidth,label,mediaQueryMatches,required,variant,margin} = props;
    if(!field) field ={};
    const context = useContext(AuthContext)

    let [data,setData] = useState(value||0);
    let step = props.step||1;
    useEffect(()=>{
        setData(value||0)
    },[value])

    if(readOnly && field && (field.is_title || (field.gridConfigs && field.gridConfigs.render))){
        
        let renderContent = value;

        if(field.gridConfigs && field.gridConfigs.render){
            let body_func = (field.gridConfigs.render.indexOf("return ")<0?"return ":"") + field.gridConfigs.render;
            try{
                let func = new Function("row","data","master","value","style","server_url","context","moment","numeral","utils",body_func);
                renderContent = func(row||{[field.name]:value},row||{[field.name]:value},master||row||{[field.name]:value},value,{},context.config.server_url,context,moment,numeral,utils);
            }catch(e){
                console.error(e,body_func);
                renderContent = e.message;
            }
        }
        return (
            <div style={{flex:1}} class="flex-text-field">
                {!!label && !field.is_title && <Typography component="div" variant="caption" class="InputLabel" style={(InputLabelProps||{}).style}><span dangerouslySetInnerHTML={{__html: label}}/> {required && <span>*</span>} </Typography>}
                <Typography style={(props.InputProps||{}).style} dangerouslySetInnerHTML={{__html:renderContent}}/>
            </div>
        )
    }
    //if(readOnly) return <Typography>{numeral(value).format(format)}</Typography>
    if(context.queryParams?.for_agent &&  (mediaQueryMatches || (window!=undefined && window.innerWidth<=480))){
        let control =  (
            <div style={{flex:1}} class="flex-number-field">
                <FormControl variant={variant} margin={margin || "normal"} fullWidth required={required}>
                    {!!label && <Typography component="div" variant="caption" class="InputLabel" style={(InputLabelProps||{}).style}><span dangerouslySetInnerHTML={{__html: label + (required?" *":'')}}/></Typography>}
                    <div style={{paddingTop:2,paddingBottom:3,border:"1px solid #B9B9B9",borderRadius:3,display:"flex",flexDirection:"row",alignItems:"center",backgroundColor:readOnly?'#f5f5f5':undefined}}>
                       {!readOnly &&  <Button variant="text" size="small" disabled={readOnly} color="primary" onClick={()=>{
                            if(readOnly) return;
                            let new_value = data-step;
                            if(field.min || field.min==0){
                                if(new_value<field.min) return;
                            }
                            setData(new_value);
                            if(onChange){
                                onChange({target:{value:new_value}});
                            }
                        }}>-</Button>}
                        <TextField
                            margin="normal"
                            required={false}
                            variant="standard"
                            type="text"
                            fullWidth
                            inputmode="numeric"
                            readOnly= {readOnly}
                            autoComplete="new-password"
                            value={data}
                            style={{margin:2}}
                            slotProps={{
                                htmlInput:{
                                    inputMode: 'decimal', pattern: '[0-9]*',
                                    style: { textAlign: 'center'},...inputProps
                                },
                                input:{
                                    readOnly: readOnly,
                                    inputComponent: NumberFormatCustom,
                                    min: field.min,
                                    max: field.max,
                                    inputmode:"numeric",
                                    disableUnderline: true,
                                    style:{overflow:"hidden"}
                                }

                            }}
                            onKeyDown={event=>{
                                if(event.key === 'Enter' &&  onChange && data!=value){
                                    onChange({target:{value:data}})
                                }
                            }}
                            onBlur={event=>{
                                if(onChange && data!=value){
                                    onChange({target:{value:data}})
                                }
                            }}
                            onChange={(event)=>{
                                let new_value = Number(event.target.value);
                                if(isNaN(new_value)){
                                    new_value =0;
                                }
                                if(field.min || field.min==0){
                                    if(new_value<field.min) return;
                                }
                                if(field.max || field.max==0){
                                    if(new_value>field.max ) return;
                                }

                                if(new_value!=data){
                                    setData(new_value);
                                }
                            }}
                        />

                        {!readOnly &&<Button  variant="text" size="small" disabled={readOnly}  color="primary"  onClick={()=>{
                            if(readOnly) return;
                            let new_value = data+step;
                            if(field.max|| field.max==0){
                                if(new_value>field.max) return;
                            }
                            setData(new_value);
                            if(onChange){
                                onChange({target:{value:new_value}});
                            }
                        }}>+</Button>}
                    </div>
                </FormControl>
            </div>
        )
        return control;
    }
    
    return (
        <TextField
            margin={margin || "none"}
            required={required}
            fullWidth={fullWidth}
            variant={variant || "standard"}
            type="text"
            autoComplete="new-password"
            readOnly= {readOnly}
            value={data}
            label={label?<span dangerouslySetInnerHTML={{__html: label}}/>:null}
            slotProps={{
                htmlInput:{
                    style: { textAlign: 'right'},
                    inputMode: 'decimal', pattern: '[0-9]*',
                    thousandSeparator:field?.name && ["nam","year","__year","tu_nam","den_nam","from_year","to_year"].indexOf(field?.name)>=0?false:true,
                    ...inputProps
                },
                input:{
                    inputComponent: NumberFormatCustom,
                    readOnly,
                    min: field.min,
                    max: field.max,
                    ...(InputProps||{})
                },
                inputLabel:{shrink: true,...InputLabelProps}

            }}
            onKeyDown={event=>{
                if(readOnly) return;
                if(event.key === 'Enter' &&  onChange && data!=value){
                    onChange({target:{value:data}})
                }
            }}
            onBlur={event=>{
                if(readOnly) return;
                if(onChange && data!=value){
                    onChange({target:{value:data}})
                }
            }}
            onChange={(event)=>{
                if(readOnly) return;
                let new_value = Number(event.target.value);
                if(isNaN(new_value)){
                    new_value =0;
                }
                if(field.min || field.min==0){
                    if(new_value<field.min) return;
                }
                if(field.max || field.max==0){
                    if(new_value>field.max ) return;
                }
                if(new_value!=data){
                    setData(new_value);
                }
            }}
            helperText={helperText}
        />
    );
}
NumberField.propTypes={
    field:PropTypes.any,
    variant:PropTypes.string,
    margin:PropTypes.string,
    value:PropTypes.number,
    onChange:PropTypes.func,
    readOnly:PropTypes.bool,
    fullWidth:PropTypes.bool,
    format:PropTypes.any,
    InputProps:PropTypes.any,
    inputProps:PropTypes.any,
    InputLabelProps:PropTypes.any,
    label:PropTypes.any,
    required:PropTypes.bool,
    mediaQueryMatches:PropTypes.bool,
}
export default NumberField;